import * as React from 'react'
import Card from '@mui/material/Card'
// import "../../../../theme.css";
import './OverviewCard.css'
// import { useSelector } from "react-redux";
// import { fetchCurrentState } from "../../../../redux/features/customerViewSlice";
import { v4 } from 'uuid'
import {
  dateFormatwithDay,
  getImageUrlFromName,
  removeDuplicatesActivity,
} from '../../../../util'
import calender_icon from '../../../../assets/images/icons/calender_icon.svg'
import confirmed_icon from '../../../../assets/images/icons/confirmed_icon.svg'
import bed_icon from '../../../../assets/images/icons/bed_icon.svg'
import activity_icon from '../../../../assets/images/icons/activity_icon.svg'
// import { overviewModel } from '../../customerViewDataModel'
import { isEmpty } from 'lodash'
import ReactReadMoreReadLess from 'react-read-more-read-less'
import { minHeight } from '@mui/system'
import TextTruncate from 'react-text-truncate'
import ReactMoreReadLess from '../../../common/ReadMoreReadLess/ReactMoreReadLess'
import { eventName } from '../../../common/Analytics/AnalyticsEvent'

// import { overviewModel } from "../../customerViewDataModel";
// import "./StaysCard.css";
// import CardActions from "@mui/material/CardActions";
// import CardContent from "@mui/material/CardContent";
// import CardMedia from "@mui/material/CardMedia";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
// import stayImage from "../../../../assets/images/stay-image.png";

export default function OverviewCard(props) {
  //  console.log(props)

  // const tripDays = tripStateData.trip_days;

  // overviewModel(tripDays)

  //  console.log(overviewModel(tripDays))

  let noteList = removeDuplicatesActivity(props.overviewData.notes, 'value')
  console.log(noteList)
  return (
    <div style={{ marginBottom: '15px' }}>
      {/* {props.tripStateData.trip_days.map((day) => { */}
      {/* return ( */}
      <div key={v4()} style={{ margin: '24px 20px 30px 20px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            lineHeight: '0px',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={calender_icon}
              alt="calender"
              style={{ marginRight: '5px' }}
            ></img>
            <p className="headline1">
              {props.overviewData.date.length > 1
                ? !isEmpty(props.overviewData.date[0]) &&
                  !isEmpty(
                    props.overviewData.date[props.overviewData.date.length - 1],
                  )
                  ? dateFormatwithDay(props.overviewData.date[0]) +
                    ' - ' +
                    dateFormatwithDay(
                      props.overviewData.date[
                        props.overviewData.date.length - 1
                      ],
                    )
                  : ' Day: ' +
                    props.overviewData.days[0] +
                    ' - ' +
                    props.overviewData.days[props.overviewData.days.length - 1]
                : !isEmpty(props.overviewData.date[props.overviewData.date[0]])
                ? dateFormatwithDay(
                    props.overviewData.date[props.overviewData.date[0]],
                  )
                : 'Day: ' + props.overviewData.date[props.overviewData.days[0]]}
            </p>
          </div>

          {/* <p className="headline1">Text</p> */}
        </div>
        <Card
          sx={{
            maxWidth: '100%',
            margin: '15px 0px 25px 0px',
            borderRadius: '8px',
            border: 'none',
            boxShadow: '2px 4px 24px rgba(11, 12, 21, 0.1)',
          }}
          variant="outlined"
        >
          <div>
            <div
              className="place-container"
              style={
                !isEmpty(noteList) && !isEmpty(noteList[0].value)
                  ? {
                      display: 'flex',
                      justifyContent: 'flex-start',
                      margin: '16px 16px',
                      marginBottom: '24px',
                    }
                  : {
                      display: 'flex',
                      justifyContent: 'flex-start',
                      margin: '16px 16px',
                      marginBottom: '-32px',
                    }
              }
            >
              <div
                style={{ width: '25%', minWidth: '56px', minHeight: '48px' }}
              >
                <img
                  style={{
                    borderRadius: '8px',
                    width: '100%',
                    height: '75%',
                  }}
                  alt="overview"
                  src={props.overviewData.image}
                ></img>
              </div>
              <div style={{ margin: '0px 15px', lineHeight: '10px' }}>
                {/* <p className="headline2" style={{ lineHeight: '22.5px' }}>
                  {props.overviewData.destinationName}
                </p> */}
                {/* <TextTruncate
                  line={1}
                  element="p"
                  truncateText="…"
                  text={props.overviewData.destinationName}
                  containerClassName="headline2"
                  style={{
                    // color: 'white',
                    lineHeight: '22.5px',
                  }}
                /> */}
                <p
                  className="headline2 truncated"
                  style={{
                    // color: 'white',
                    lineHeight: '22.5px',
                  }}
                >
                  {props.overviewData.destinationName}
                </p>
                <p className="body4">{props.overviewData.days.length} Days</p>
              </div>
            </div>

            {noteList.map((note) => {
              if (!isEmpty(note)) {
                let iconURL = getImageUrlFromName(note.icon)
                // console.log('>>>>>iconURL:: ', note.icon)
                return (
                  !isEmpty(note.value) && (
                    <div
                      key={v4()}
                      className="notes-div"
                      style={{ margin: '-16px 0px 16px 16px', width: '90%' }}
                    >
                      <div style={{ display: 'inline-flex' }}>
                        <span>
                          <img
                            src={iconURL}
                            alt=""
                            className="notes-icon"
                            style={{
                              width: '20px',
                              height: 'auto',
                              marginTop: '5px',
                            }}
                          ></img>
                        </span>
                        <p
                          className="body3 notes-para"
                          style={{ color: 'var(--gray100)' }}
                        >
                          {/* <ReactReadMoreReadLess
                            charLimit={70}
                            readMoreText={'Read more ˅'}
                            readLessText={'Read less ˄'}
                            readMoreStyle={{
                              color: '#00857D',
                              cursor: 'pointer',
                            }}
                            readLessStyle={{
                              color: '#00857D',
                              cursor: 'pointer',
                            }}
                          >
                            {note.value}
                          </ReactReadMoreReadLess> */}

                          <ReactMoreReadLess
                            moreText={'Read more'}
                            lessText={'Read less'}
                            showArrow={true}
                            lines={'3'}
                            analytics={true}
                            analyticsProps={{
                              page: 'Overview',
                              eventName: eventName.Overview_note_expanded,
                            }}
                          >
                            {note.value}
                          </ReactMoreReadLess>
                        </p>
                      </div>
                    </div>
                  )
                )
              }
            })}
            <div style={{ marginBottom: '32px', marginTop: '24px' }}>
              <div style={{ marginRight: '10px', marginBottom: '8px' }}>
                {!isEmpty(
                  props.overviewData.activityandStayList.uniqueStayList,
                ) && (
                  <div
                    style={{
                      display: 'flex',
                      marginLeft: '15px',
                      // marginBottom: '0px',
                    }}
                  >
                    <img
                      src={bed_icon}
                      alt="bed_icon"
                      style={{ minWidth: '20px', minHeight: '20px' }}
                    ></img>
                    <p
                      className="headline2"
                      style={{
                        color: 'var(--gray100)',
                        marginLeft: '10px',
                      }}
                    >
                      Stays
                    </p>
                  </div>
                )}

                {props.overviewData.activityandStayList.uniqueStayList.map(
                  (stay) => {
                    return (
                      <div key={v4()}>
                        <div style={{}} key={v4()}>
                          {stay.booking_status === 'BOOKING_CONFIRMED' ? (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                              }}
                            >
                              <img
                                src={confirmed_icon}
                                alt="confirmed_icon"
                                style={{
                                  marginLeft: '15px',
                                  minWidth: '20px',
                                  minHeight: '20px',
                                }}
                              ></img>
                              <p
                                className="body3 truncated"
                                style={{
                                  color: 'var(--gray80)',
                                  marginLeft: '10px',
                                  marginTop: '0px',
                                }}
                              >
                                {stay.item}
                              </p>
                            </div>
                          ) : (
                            <p
                              className="body3 truncated"
                              style={{
                                color: 'var(--gray80)',
                                marginLeft: '45px',
                                marginTop: '0px',
                              }}
                            >
                              {stay.item}
                            </p>
                          )}
                          {/* <p
                        className="body3"
                        style={{
                          color: 'var(--gray80)',
                          marginLeft: '45px',
                          marginTop: '0px',
                        }}
                      >
                        {item.display_name}
                      </p> */}
                        </div>
                      </div>
                    )
                  },
                )}
              </div>
              <div style={{ marginRight: '15px' }}>
                {!isEmpty(
                  props.overviewData.activityandStayList.uniqueActivityList,
                ) && (
                  <div
                    style={{
                      display: 'flex',
                      marginLeft: '15px',
                      // marginBottom: '0px',
                    }}
                  >
                    <img
                      src={activity_icon}
                      alt="activity_icon"
                      style={{ minWidth: '20px', minHeight: '20px' }}
                    ></img>
                    <p
                      className="headline2"
                      style={{
                        color: 'var(--gray100)',
                        marginLeft: '10px',

                        // marginBottom: '0px',
                      }}
                    >
                      {/* {item.item_type} */}
                      Activity
                    </p>
                  </div>
                )}
                {props.overviewData.activityandStayList.uniqueActivityList.map(
                  (activity) => {
                    return (
                      <div key={v4()}>
                        <div style={{}} key={v4()}>
                          {activity.booking_status === 'BOOKING_CONFIRMED' ? (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                              }}
                            >
                              <img
                                src={confirmed_icon}
                                alt="confirmed_icon"
                                style={{
                                  marginLeft: '15px',
                                  minWidth: '20px',
                                  minHeight: '20px',
                                }}
                              ></img>
                              <p
                                className="body3 truncated"
                                style={{
                                  color: 'var(--gray80)',
                                  marginLeft: '10px',
                                  marginTop: '0px',
                                }}
                              >
                                {activity.item}
                              </p>
                            </div>
                          ) : (
                            <p
                              className="body3 truncated"
                              style={{
                                color: 'var(--gray80)',
                                marginLeft: '45px',
                                marginTop: '0px',
                              }}
                            >
                              {activity.item}
                            </p>
                          )}
                          {/* <p
                        className="body3"
                        style={{
                          color: 'var(--gray80)',
                          marginLeft: '45px',
                          marginTop: '0px',
                        }}
                      >
                        {item.display_name}
                      </p> */}
                        </div>
                      </div>
                    )
                  },
                )}
              </div>
            </div>
          </div>
        </Card>
      </div>
      {/* ) */}
      {/* })} */}
    </div>
  )
}
